module.exports = __webpack_public_path__ + "site/img/index5-newyear.3dedfb06.png";